module.exports = __webpack_public_path__ + "static/media/dwnew.fa66c70b.png";